import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/en-au';
import StatsList from '../../components/Activity/StatsList';
import StatTitleLink from '../../components/Activity/StatTitleLink';
import {
  selectPlaylistsStatsData,
  selectHasLoadedPlaylistsStatsData,
} from '../../lib/store/selectors/activity';
import { APP_ROUTES } from '../../lib/constants/app-routes';
import { GQL_STATISTICS_CONTENT_TYPE } from '../../lib/constants';
import { useGetStats } from './useGetStats';
moment.locale('en-au');

function Playlists({ stats, hasLoaded }) {
  const { fetchStats, loading } = useGetStats({
    type: GQL_STATISTICS_CONTENT_TYPE.playlists,
  });

  React.useEffect(() => {
    if (!hasLoaded) {
      const thirtyDaysAgo = moment().subtract(1, 'month').startOf('day');
      fetchStats(thirtyDaysAgo.toISOString());
    }
  }, [hasLoaded]);

  const renderRowTitle = (_, folderName, parentFolderId) => {
    if (folderName === 'Unknown (DELETED)') return folderName;
    return (
      <StatTitleLink
        link={`${APP_ROUTES.playlists}/${parentFolderId}`}
        linkText={folderName}
        titleType="Playlist Media"
      />
    );
  };

  const refreshData = () => {
    const thirtyDaysAgo = moment().subtract(1, 'month').startOf('day');
    fetchStats(thirtyDaysAgo.toISOString());
  };

  return (
    <StatsList
      stats={stats}
      isLoading={loading}
      renderRowTitle={renderRowTitle}
      onClickRefresh={refreshData}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    stats: selectPlaylistsStatsData(state),
    hasLoaded: selectHasLoadedPlaylistsStatsData(state),
  };
};

export default connect(mapStateToProps)(Playlists);
